import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export default function CatturaLattimo() {
  return <section id="cattura-lattimo" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/retroscatti_logo_watermark.png" alt="RetroScatti Logo Watermark" className="w-[120%] max-w-none md:w-[80%] opacity-[0.03] animate-pulse object-contain transform scale-110" style={{
        animationDuration: "8s"
      }} />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center !bg-[url(https://italianminuteros.com/wp-content/uploads/2026/03/bb.jpg)]">
        <div className="max-w-4xl mx-auto space-y-12">
          {}
          <h2 className="font-serif text-5xl md:text-7xl lg:text-9xl font-medium tracking-tighter leading-[0.9] text-foreground drop-shadow-2xl">Capture<br /><span className="italic text-primary/90" data-ast-id="f:/src/pages/Home/sections/CatturaLattimo.tsx|sig:yf0xqj" data-ast-start="1250" data-ast-end="1305" contenteditable="false" style={{}}>Forever</span></h2>

          {}
          <div className="pt-8">
            <Button asChild variant="outline" size="lg" className={cn("h-16 px-12 text-xl md:text-2xl border-2 rounded-none transition-all duration-500", "border-primary text-primary bg-transparent", "hover:bg-primary hover:text-primary-foreground hover:border-primary hover:shadow-[0_0_30px_-5px_var(--color-primary)]")}>
              <Link to="/ContactPage">Contact Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}